import { apiEndPoints } from './api.endPoints';
import { HttpService } from './http.service';
import { IKeyValMap } from './interfaces/IKeyValMap';

/**
 * Class to manage metadata. Once fetched from the backend data will be cached
 * in memory.
 */
export class MetadataService {
  private applicationStagesFetch: Promise<IKeyValMap> | null = null;
  private applicationStages: IKeyValMap = {};
  private applicationLifecyclesFetch: Promise<IKeyValMap> | null = null;
  private applicationLifecycles: IKeyValMap = {};
  private applicationDetailedLifecycles: IKeyValMap = {};
  private applicationDetailedLifecyclesFetch: Promise<IKeyValMap> | null = null;

  public async getApplicationStages(): Promise<IKeyValMap> {
    // Fetch from the backend if this is the first time this data is requested.
    if (this.applicationStagesFetch === null) {
      const url = apiEndPoints.applicationStage;

      this.applicationStagesFetch = HttpService.getInstance().get(url);
      const data: IKeyValMap = await this.applicationStagesFetch;

      const items = data.parsedBody;
      if (items?.length) {
        this.applicationStages = items.reduce(
          (acc: IKeyValMap, el: { name: string }) => {
            acc[el.name] = el;
            return acc;
          },
          {},
        );
      }
    }

    // We always need to await that because it may happen that call to this
    // function was made when fetching was in progress.
    await this.applicationStagesFetch;

    return this.applicationStages;
  }

  public async getApplicationLifecycles(): Promise<IKeyValMap> {
    // Fetch from the backend if this is the first time this data is requested.
    if (this.applicationLifecyclesFetch === null) {
      const url = apiEndPoints.applicationLifecycle;

      this.applicationLifecyclesFetch = HttpService.getInstance().get(url);
      const data: IKeyValMap = await this.applicationLifecyclesFetch;

      const items = data.parsedBody;
      if (items?.length) {
        this.applicationLifecycles = items.reduce(
          (acc: IKeyValMap, el: { name: string }) => {
            acc[el.name] = el;
            return acc;
          },
          {},
        );
      }
    }

    // We always need to await that because it may happen that call to this
    // function was made when fetching was in progress.
    await this.applicationLifecyclesFetch;

    return this.applicationLifecycles;
  }

  public async getApplicationDetailedLifecycles(): Promise<IKeyValMap> {
    // Fetch from the backend if this is the first time this data is requested.
    if (this.applicationDetailedLifecyclesFetch === null) {
      const url = apiEndPoints.applicationDetailedLifecycle;

      this.applicationDetailedLifecyclesFetch =
        HttpService.getInstance().get(url);
      const data: IKeyValMap = await this.applicationDetailedLifecyclesFetch;

      const items = data.parsedBody;
      if (items?.length) {
        this.applicationDetailedLifecycles = items.reduce(
          (acc: IKeyValMap, el: { name: string }) => {
            acc[el.name] = el;
            return acc;
          },
          {},
        );
      }
    }

    // We always need to await that because it may happen that call to this
    // function was made when fetching was in progress.
    await this.applicationDetailedLifecyclesFetch;

    return this.applicationDetailedLifecycles;
  }
}

export default new MetadataService();
